import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import {
  AuthService,
  LocalStorageKey,
  LocalStorageService,
  OAuthTokenResponse
} from '@garmin-avcloud/avcloud-web-utils';
import { Observable, of, switchMap, tap, throwError } from 'rxjs';

import { environment } from 'src/environments/environment';

export interface UserConfig {
  isCustomerUser: boolean;
  isDealerUser: boolean;
  isOemDistributor: boolean;
  isFleet: boolean;
  isOemUser: boolean;
  loggedInUserCustomerGuid: string;
  loggedInUserEmail?: string;
  detectedLocale?: string;
  detectedCountry?: string;
  primaryAddressCountry?: string;
}

const UserUrl = '/api/user-info';

@Injectable({
  providedIn: 'root'
})
export class UserConfigService {
  private cache?: UserConfig;
  private readonly authService = inject(AuthService);
  private readonly http = inject(HttpClient);
  private readonly localStorageService = inject(LocalStorageService);

  getUserConfig(): Observable<UserConfig> {
    const customerGuid = this.localStorageService.get<OAuthTokenResponse>(
      LocalStorageKey.OAuthTokenResponse
    )?.customerId;

    if (this.cache != null && customerGuid === this.cache.loggedInUserCustomerGuid) {
      return of(this.cache);
    }

    return this.load();
  }

  private load(): Observable<UserConfig> {
    return this.authService.isAuthenticated().pipe(
      switchMap((isAuth) =>
        !isAuth ? throwError(() => new Error('not authenticated')) : this.http.get<UserConfig>(getUserConfigUrl())
      ),
      tap((userConfig) => (this.cache = userConfig))
    );
  }
}

export const getUserConfigUrl = (): string => {
  return `${environment.flyLegacyUrl}${UserUrl}`;
};
